import HeaderBaseContent from './base.header';
import {cmsStringToType, cmsTypeToString, TYPE_HEADER_TWO} from '../constants';
import { List } from 'immutable';
import BaseContent, {AContent, AContentDTO} from "../base.content";
import {CMSContentType} from "../CMSType";
import {HeaderOneContent, HeaderOneContentParams} from "./header-one.content";
import {cmsContentMapperFactory} from "../content/mappers";
import {IContentMapper} from "../content/base.content";
import {TransfersContentDTO} from "../content/transfers.content";
import {PlayerListContentDTO} from "../content/player-list.content";

const defaultParams = {} as HeaderOneContentParams;

export class HeaderTwoContent extends HeaderBaseContent<AContent> {
  public hasShowAll: boolean = false;
  protected _type: string = TYPE_HEADER_TWO;
  constructor(data: HeaderOneContentParams = defaultParams) {
    // super(CMSContentType.headerTwo, { label: ''} as HeaderOneContentParams);
    super(CMSContentType.headerTwo, data);
  }

  public addChild(content: AContent): HeaderTwoContent {
    return this.push(content);
  }

  updateListItem(oldItem: AContent, newItem: AContent): this {
    return this.updateList(this.items.set(this.items.indexOf(oldItem), newItem));
  }
}

export interface HeaderTwoContentDTO extends AContentDTO {
  label: string;
  children: Array<AContentDTO>;
}


export class HeaderTwoContentMapper implements IContentMapper {
  toDTO(data: HeaderTwoContent): HeaderTwoContentDTO {
    return {
      label: data.label,
      type: cmsTypeToString(data.type),
      children: data.items.toArray()
        .map((item) => cmsContentMapperFactory(item.type).toDTO(item))
    };
  }

  fromDTO(data: HeaderTwoContentDTO): HeaderTwoContent {
    return new HeaderTwoContent({
      label: data.label,
      items: data.children.map((item) =>
        cmsContentMapperFactory(cmsStringToType(item.type)).fromDTO(item)
      )
    });
  }
}

export default HeaderTwoContent;



// WEBPACK FOOTER //
// ./src/api/club-cms/headers/header-two.content.ts